import { GenericCrudPage } from '@/components/GenericCrudPage';
import { notificationsConfig } from '@/pages/configs';

export default function NotificationsPage() {
  return <GenericCrudPage config={notificationsConfig} />;
}
